import React, { useState, useEffect } from 'react'
import { Box, Layer, Text } from "grommet"

import HealthStatusService from '../health2/details/HealthStatusService'
import HealthStatusNodeChef from '../health2/details/HealthStatusNodeChef'

import * as beautify from "json-beautify"
import TTJsonTree from '../common/TTJsonTree'
import TTCopyClipboard from '../common/TTCopyClipboard'

const AlertDetailedView = ({ serviceInstanceSelected, nodeTypeSelected, serviceGroupSelected, nodeSelected, customOutput }) => {

    const [hideView, setHideView] = useState(false)

    const toggleView = () => {
        setHideView(!hideView)
    }

    useEffect(() => {
        setHideView(false)
    }, [serviceInstanceSelected, nodeTypeSelected, serviceGroupSelected, nodeSelected, customOutput])


    return (
        <>
            {!hideView &&
                <Layer
                    position="right"
                    modal={true}
                    full="vertical"
                    background='light-3'
                    onEsc={() => {
                        toggleView()
                    }}
                    onClickOutside={() => {
                        toggleView()
                    }}
                >

                    <AlertDetailedViewInner
                        serviceInstanceSelected={serviceInstanceSelected}
                        nodeTypeSelected={nodeTypeSelected}
                        serviceGroupSelected={serviceGroupSelected}
                        nodeSelected={nodeSelected}
                        customOutput={customOutput}
                    />

                </Layer>
            }
        </>

    )
}

export const AlertDetailedViewInner = ({ serviceInstanceSelected, nodeTypeSelected, serviceGroupSelected, nodeSelected, customOutput }) => {

    return (
        <Box gap="small" background='light-1' alignContent="start" width="1000px" fill="vertical">
            <Box fill background='light-1' overflow={{ horizontal: 'hidden', vertical: 'auto' }} pad="xsmall">

                {customOutput &&
                    <Box
                        fill
                        gap='none'
                        pad='small'
                        background="light-1"
                    >
                        <Box direction="row" margin={{ top: "small", left: "xsmall", right: "xsmall" }} fill="horizontal" align="start" alignContent="start" alignSelf="start">
                            <Text color="dark-3" size="small" margin="none" weight="bold">Bouncer Diagnostics Output</Text>
                            <TTCopyClipboard copyText={beautify(customOutput, null, 2, 80)} />
                        </Box>
                        <Box overflow={{ horizontal: 'hidden', vertical: 'auto' }}>
                            <TTJsonTree data={customOutput} expandAll={true} />
                        </Box>
                    </Box>
                }

                {serviceInstanceSelected !== "" &&
                    <HealthStatusService
                        serviceInstanceSelected={serviceInstanceSelected}
                        nodeName={nodeSelected}
                    />
                }
                {nodeTypeSelected === "chef" && nodeSelected !== "" &&
                    <HealthStatusNodeChef
                        serviceGroupSelected={serviceGroupSelected}
                        nodeSelected={nodeSelected}
                    />
                }

            </Box>
        </Box>
    )

}

export default AlertDetailedView
